export const shouldBeAn = (nextWord) => {
  return nextWord.match(/^[aeiou]/i) ? "an" : "a";
}

export const titleCase = (word) => {
  return word.charAt(0).toUpperCase() + word.slice(1);
}